import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartPulse, X } from "lucide-react";

import { Button } from "@/components/ui/button";
import { nudgeAccentStyles } from "@/components/nudges/accent-styles";
import { pulseChatSetupNudgeDismissKey } from "@/components/nudges/types";
import { cn } from "@/lib/utils";
import { LogEvents, track } from "@/analytics/track";

const PULSE_SETUP_PATH = "/coach/performance/pulse";

export function PulseSetupChatNudge() {
  const dismissKey = pulseChatSetupNudgeDismissKey();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(dismissKey) === "true",
  );

  useEffect(() => {
    if (!dismissed) {
      track({
        event: LogEvents.PulseNudgeShown.name,
        channel: LogEvents.PulseNudgeShown.channel,
        surface: "coach",
        kind: "setup",
      });
    }
  }, [dismissed]);

  if (dismissed) return null;

  const accent = nudgeAccentStyles.info;

  const handleDismiss = () => {
    sessionStorage.setItem(dismissKey, "true");
    setDismissed(true);
    track({
      event: LogEvents.PulseNudgeDismiss.name,
      channel: LogEvents.PulseNudgeDismiss.channel,
      surface: "coach",
      kind: "setup",
    });
  };

  const handleCta = () => {
    track({
      event: LogEvents.PulseNudgeCta.name,
      channel: LogEvents.PulseNudgeCta.channel,
      surface: "coach",
      kind: "setup",
      action: "configure_pulse",
    });
  };

  return (
    <div
      className={cn(
        "mb-4 w-full rounded-xl border border-border border-l-4 p-4 text-left shadow-sm",
        accent.rail,
        accent.card,
      )}
    >
      <div className="flex items-start gap-3">
        <div
          className={cn(
            "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg",
            accent.icon,
          )}
        >
          <HeartPulse className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-start justify-between gap-2">
            <div>
              <p className="font-semibold text-foreground">
                Konfigurera Pulse check-in
              </p>
              <p className="mt-0.5 text-sm text-muted-foreground">
                Välj hur ofta ert team ska göra check-in och gör er första
                bedömning på fyra signaler.
              </p>
            </div>
            <button
              type="button"
              onClick={handleDismiss}
              className="rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground"
              aria-label="Stäng påminnelse"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="mt-3">
            <Button asChild size="sm" onClick={handleCta}>
              <Link to={PULSE_SETUP_PATH}>
                Konfigurera Pulse
                <ArrowRight className="ml-1 h-3.5 w-3.5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
